import React from "react";
import i18n from "../lang/i18n";
import {mdiAlert} from "@mdi/js";
import Icon from "@mdi/react";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({visible}: {visible: boolean}) => {

    if (!visible) {
        return null;
    }

    return (
        <div className="alert alert-warning">
            <Icon className="text-primary" path={mdiAlert} size={1}/> {i18n.t('2757')}
        </div>
    );
}